import { crudService } from '../_services/';
import alerts from '../_components/alerts';

export const logErroGeralAction = {
    getLogErroGeral
};

function getLogErroGeral() {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'log/erros';
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeLogsList(response.data));
                alerts.clean();
            })
    };
}

export function changeLogsList(logErroGeral) {
    return {
        type: "FETECHED_ALL_LOG_ERRO_GERAL",
        logErroGeral: logErroGeral
    }
}